import {
  Box,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  Stack
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { SalarySacrificeStatus } from "../../../models/salarySacrifices/salarySacrifice";

interface SalarySacrificesTableControlBarProps {
  selectedStatuses?: SalarySacrificeStatus[];
  onStatusesChange?: (statuses: SalarySacrificeStatus[]) => void;
}

export const SalarySacrificesTableControlBar: React.FC<
  SalarySacrificesTableControlBarProps
> = ({ selectedStatuses = [], onStatusesChange }) => {
  const handleStatusChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    const statuses = typeof value === "string" ? [value] : value;
    onStatusesChange?.(statuses as SalarySacrificeStatus[]);
  };

  const availableStatuses = Object.values(SalarySacrificeStatus).filter(
    (status) =>
      status !== SalarySacrificeStatus.CREATED
  );

  return (
    <Box display="flex" width="100%" justifyContent="flex-start">
      <Stack direction="row" spacing={2} my={2}>
        {availableStatuses.length > 0 && onStatusesChange && (
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <Select
              multiple
              value={selectedStatuses}
              onChange={handleStatusChange}
              displayEmpty
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return "Status";
                }
                return availableStatuses
                  .filter((status) => selected.includes(status))
                  .map((status) => status.replace(/_/g, " "))
                  .join(", ");
              }}
            >
              {availableStatuses.map((status) => (
                <MenuItem key={status} value={status}>
                  <Checkbox checked={selectedStatuses.includes(status)} />
                  <ListItemText primary={status.replace(/_/g, " ")} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Stack>
    </Box>
  );
};
